import React from "react";
// import { Nav as IconsNav } from "@magnetic/icons";
import { Nav as MNav } from "@magnetic/nav";
import { Divider } from "@magnetic/divider";
import NavIcon from "./nav-icon";
import "./nav-item-styles.scss";

function NavItem({ item, i18nNamespace, i18n, navItemClick, getActive }) {
  const { id, drawerContentId, label, heading = "", icon, isSwitcher = false, isNew = false, isDivider = false, href = "" } = item;
  console.log("icon NavItem-----", icon);
  const additionalProps = {};
  if (heading) {
    additionalProps.heading = i18n?.t(heading, { ns: i18nNamespace }) || heading;
  }

  if (isDivider) {
    return <Divider />;
  }

  if (href) {
    return (
      <MNav.Item
        key={id}
        as="a"
        href={href}
        className="nav-item-link nav-menu-blue"
        drawerContentId={drawerContentId}
        label={i18n?.t(label, { ns: i18nNamespace }) || label}
        icon={<NavIcon icon={icon} />}
        switcher={isSwitcher}
        isNew={isNew}
        isSelected={getActive(item)}
        onClick={(e) => navItemClick(e, item)}
        {...additionalProps}
      />
    );
  }

  return (
    <MNav.Item
      key={id}
      className="nav-menu-blue"
      drawerContentId={drawerContentId}
      label={i18n?.t(label, { ns: i18nNamespace }) || label}
      icon={<NavIcon icon={icon} />}
      switcher={isSwitcher}
      isNew={isNew}
      isSelected={getActive(item)}
      onClick={(e) => navItemClick(e, item)}
      {...additionalProps}
    />
  );
}

export default NavItem;
